import React from "react";
import "../styles/About.css"; // Banner styling
import "../styles/PrivacyPolicy.css"; // Custom styles

const PrivacyPolicy = () => {
  return (
    <>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Privacy Policy</h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/privacy-policy">Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy_policy_area container py-5">
        <h3>Overview</h3>
        <p>
          This Privacy Policy governs your use of our websites, services, and all communications with Learnific. We prioritize your privacy and are committed to protecting your personal data. This policy outlines what data we collect, how we use it, and your rights regarding it.
        </p>

        <h3>Consent & Agreement</h3>
        <p>
          By accessing our services or submitting your information, you consent to this Privacy Policy. If you do not agree with any part of it, we recommend refraining from sharing personal data or using our services.
        </p>

        <h3>How We Use Your Information</h3>
        <ul>
          <li>To deliver services you have requested</li>
          <li>To analyze platform usage and improve our offerings</li>
          <li>To personalize your experience</li>
          <li>To fulfill legal, accounting, or contractual obligations</li>
        </ul>

        <h3>Legal Grounds for Data Processing</h3>
        <p>
          We collect and process personal information under the following legal bases:
        </p>
        <ul>
          <li>Consent provided by the user</li>
          <li>Performance of a contract or service</li>
          <li>Legal compliance and obligations</li>
        </ul>

        <h3>Information We Collect</h3>
        <ul>
          <li><strong>Contact Details:</strong> name, email, phone, mailing address, IP address</li>
          <li><strong>Business Info:</strong> company name, size, industry type</li>
          <li><strong>Payment Info:</strong> securely processed via payment gateways; we do not store card details</li>
          <li><strong>Usage Data:</strong> activity logs, feedback, and support requests</li>
        </ul>

        <h3>Learning Platform & Feedback</h3>
        <p>
          When using our Learning Management System (e.g., StartOnboard), support portal, or surveys, we may collect usernames, feedback, and location data to personalize support and track progress.
        </p>

        <h3>Anonymous Usage</h3>
        <p>
          You may access our website anonymously. Personally identifiable data is collected only when voluntarily submitted.
        </p>

        <h3>Non-Personal Data Collected</h3>
        <ul>
          <li>Language and browser settings</li>
          <li>Device type and screen resolution</li>
          <li>Referring pages and site interactions</li>
        </ul>

        <h3>Cookies</h3>
        <p>
          Cookies are used to improve user experience. You may disable cookies via your browser settings, but doing so may affect certain site functions.
        </p>

        <h3>Copyright & Content</h3>
        <p>
          All content, including text, images, and videos, are owned by Learnific unless stated otherwise. Reuse without permission is prohibited. Course content may change at any time without notice.
        </p>

        <h3>Images, Videos & Testimonials</h3>
        <p>
          Visual media captured during Learnific events may be used for training or promotional purposes. Testimonials, photos, or videos will only be shared publicly with your permission.
        </p>

        <h3>Call Recordings</h3>
        <p>
          We may record calls for training and quality assurance. These recordings are kept secure and are never shared externally.
        </p>

        <h3>Data Retention Policy</h3>
        <ul>
          <li>Business customers: based on contract duration</li>
          <li>Consumer data: retained as long as needed for service</li>
          <li>Legal or financial data: retained per compliance standards</li>
        </ul>

        <h3>Data Storage & Transfer</h3>
        <p>
          All user data is securely stored in India-based data centers. We do not transfer your data internationally without ensuring privacy compliance.
        </p>

        <h3>Third-Party Providers</h3>
        <p>
          Learnific uses trusted cloud service providers like AWS, GCP, and Azure. Any future third-party data sharing will be subject to legal data processing agreements.
        </p>

        <h3>Data Security</h3>
        <p>
          We implement technical, administrative, and organizational safeguards to prevent unauthorized access, data modification, and unavailability.
        </p>

        <h3>Contact Us</h3>
        <p>
          For any questions or concerns about this Privacy Policy, please email us at: <br />
          <strong>vectorisadvisory@gmail.com</strong>
        </p>
      </section>
    </>
  );
};

export default PrivacyPolicy;
